import { cn } from '@/lib/cn';

const logoSources = {
  horizontal: '/images/Adsperianx%20Logo-09.png',
  stacked: '/images/Adsperianx%20Logo-01.png',
} as const;

type BrandLogoProps = {
  variant?: keyof typeof logoSources;
  className?: string;
  alt?: string;
};

export default function BrandLogo({
  variant = 'horizontal',
  className,
  alt = 'ADSPERIANX SOLUTIONS',
}: BrandLogoProps) {
  return (
    <img
      src={logoSources[variant]}
      alt={alt}
      className={cn('w-auto object-contain', className)}
    />
  );
}
